// Debug utilities for better error tracking
export const debugUtils = {
  // Enhanced console logging with timestamps and context
  log: (message, data = null, context = 'App') => {
    const timestamp = new Date().toISOString()
    // Debug logging disabled
  },

  // Error logging with stack trace
  error: (message, error = null, context = 'App') => {
    const timestamp = new Date().toISOString()
    console.group(`🚨 [${timestamp}] [${context}] ${message}`)
    if (error) {
      console.error('Error object:', error)
      console.error('Stack trace:', error.stack)
      console.error('Error message:', error.message)
    }
    console.groupEnd()
  },

  // Warning with context
  warn: (message, data = null, context = 'App') => {
    const timestamp = new Date().toISOString()
    console.warn(`⚠️ [${timestamp}] [${context}] ${message}`, data)
  },

  // Function call tracing
  trace: (functionName, args = null, context = 'App') => {
    const timestamp = new Date().toISOString()
    // Debug tracing disabled
  },

  // Component lifecycle tracking
  lifecycle: (componentName, lifecycleHook, data = null) => {
    const timestamp = new Date().toISOString()
    // Debug lifecycle tracking disabled
  },

  // API call tracking
  api: (endpoint, method = 'GET', data = null) => {
    const timestamp = new Date().toISOString()
    // Debug API tracking disabled
  },

  // Performance timing
  time: (label) => {
    console.time(`⏱️ ${label}`)
  },

  timeEnd: (label) => {
    console.timeEnd(`⏱️ ${label}`)
  }
}

// Global error tracking
export const setupGlobalErrorTracking = () => {
  // Catch unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    debugUtils.error('Unhandled Promise Rejection', event.reason, 'Global')
    console.error('Promise rejection details:', {
      reason: event.reason,
      promise: event.promise,
      timestamp: new Date().toISOString()
    })
  })

  // Catch global JavaScript errors
  window.addEventListener('error', (event) => {
    debugUtils.error('Global JavaScript Error', event.error, 'Global')
    console.error('Error details:', {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      error: event.error,
      timestamp: new Date().toISOString()
    })
  })
}

// Function to enable detailed Vue debugging
export const enableVueDebugging = () => {
  if (typeof window !== 'undefined') {
    // Enable Vue devtools
    window.__VUE_DEVTOOLS_GLOBAL_HOOK__ = window.__VUE_DEVTOOLS_GLOBAL_HOOK__ || {}
    
    // Add debugging flag
    window.DEBUG_MODE = true
    
    // Vue debugging enabled
  }
}
